module.exports = __webpack_public_path__ + "static/ogpImage_ssd-tour-76d4a304121532eb4467d3851194a330.png";